/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import Select from 'react-select';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import PropTypes from 'prop-types';
import { customStyle, formatNumber } from 'helper';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import useFormValidator from 'useFormValidator';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import * as action from '../action';
import * as c from '../constant';
import { DISPATCHED_OTP_DATA } from '../../settings/otpModule/constant';

function ProfileEditModal({
  updating,
  taxpayers,
  taxpayerId,
  createInput,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  regionsList,
  municipalityList,
  provinceList,
  updateProfile,
  showTransaction,
  handleVerifyOtp,
}) {
  const setModal = useContext(ModalContext);
  const taxpayer = _.get(taxpayers, 'attributes');
  // fetch registered_account and change_mobile_number from OTPModuleContent.js
  const otpModuleData = useSelector(({ api }) =>
    _.get(api, `${DISPATCHED_OTP_DATA}.item`)
  );

  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    extension_name: '',
    email: '',
    birth_date: '',
    mobile_number: '',
    gender: '',
    photo: '',
    place_of_birth_municipality_code: '',
  });

  const commonValidation = {
    first_name: 'required',
    last_name: 'required',
    birth_date: 'required',
    gender: 'required',
    photo: 'required',
    place_of_birth_region_code: 'required',
    place_of_birth_province_code: 'required',
    place_of_birth_municipality_code: 'required'
  };

  const validateForm = useFormValidator(formData, commonValidation);

  const [formMobile, setFormMobile] = useState({});

  const [region, setRegion] = useState({
    label: _.get(taxpayer, 'place_of_birth_region_name') || '',
    value: _.get(taxpayer, 'place_of_birth_region_code') || '',
  });

  const [province, setProvince] = useState({
    label: _.get(taxpayer, 'place_of_birth_province_name') || '',
    value: _.get(taxpayer, 'place_of_birth_province_code') || '',
  });

  const [municipality, setMunicipality] = useState({
    label:
      _.get(taxpayer, 'place_of_birth_municipality_name') || '',
    value:
      _.get(taxpayer, 'place_of_birth_municipality_code') || '',
  });

  const updateData = () => {
    showTransaction(taxpayerId);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      first_name: _.get(formData, 'first_name')
        ? _.get(formData, 'first_name').toUpperCase()
        : '',
      middle_name: _.get(formData, 'middle_name')
        ? _.get(formData, 'middle_name').toUpperCase()
        : '',
      last_name: _.get(formData, 'last_name')
        ? _.get(formData, 'last_name').toUpperCase()
        : '',
      mobile_number: _.get(formMobile, 'mobile_number'),
      photo: _.get(formData, 'photo'),
      birth_date: _.get(formData, 'birth_date')
        ? `${moment(_.get(formData, 'birth_date')).format('MM/DD/YYYY')}`
        : '',
      mother_maiden_first_name: _.get(formData, 'mother_maiden_first_name')
        ? _.get(formData, 'mother_maiden_first_name').toUpperCase()
        : '',
      mother_maiden_last_name: _.get(formData, 'mother_maiden_last_name')
        ? _.get(formData, 'mother_maiden_last_name').toUpperCase()
        : '',
      mother_maiden_middle_name: _.get(formData, 'mother_maiden_middle_name')
        ? _.get(formData, 'mother_maiden_middle_name').toUpperCase()
        : '',
    };

    updateProfile(taxpayerId, args, () => {
      if (
        _.get(formMobile, 'mobile_number') ===
        taxpayer.mobile_number
      ) {
        setModal({ isOpen: false });
        updateData();
      }

      if (
        _.get(formMobile, 'mobile_number') !==
          taxpayer.mobile_number &&
        _.get(otpModuleData, 'change_mobile_number') === 0
      ) {
        setModal({ isOpen: false });
        updateData();
      }

      if (
        _.get(formMobile, 'mobile_number') !==
          taxpayer.mobile_number &&
        _.get(otpModuleData, 'change_mobile_number') === 1
      ) {
        setModal({ isOpen: false });
        handleVerifyOtp();
      }
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnChangeSelect = (name) => (data) => {
    setFormData({
      ...formData,
      [name]: data.value,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleRegionSelect = (e) => {
    setRegion(e);
    setFormData({
      ...formData,
      place_of_birth_region_code: e.value,
    });
    getProvinceList({ region_code: e.value });
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    setFormData({
      ...formData,
      place_of_birth_province_code: e.value,
    });
    getMunicipalityList({ province_code: e.value });
  };

  const handleMunicipalitySelect = (e) => {
    setMunicipality(e);
    setFormData({
      ...formData,
      place_of_birth_municipality_code: e.value,
    });
    getBarangayList({ municipality_code: e.value });
  };

  const OnSetFormData = () => {
    setFormMobile({
      mobile_number: formatNumber(taxpayer.mobile_number || ''),
    });

    setFormData({
      photo: taxpayer.photo || '',
      is_resident: taxpayer.is_resident,
      first_name: taxpayer.first_name || '',
      last_name: taxpayer.last_name || '',
      middle_name: taxpayer.middle_name || '',
      mobile_number: formatNumber(taxpayer.mobile_number || ''),
      telephone_number: taxpayer.telephone_number || '',
      email: taxpayer.email || '',
      user_id: taxpayer.user_id || '',
      birth_date: taxpayer.birth_date || '',
      street: taxpayer.street || '',
      civil_status: taxpayer.civil_status || '',
      gender: taxpayer.gender || '',
      place_of_birth_region_code:
        taxpayer.place_of_birth_region_code || '',
      place_of_birth_municipality_code:
        taxpayer.place_of_birth_municipality_code || '',
      place_of_birth_province_code:
        taxpayer.place_of_birth_province_code || '',
      extension_name: taxpayer.extension_name || '',
      mother_maiden_first_name: taxpayer.mother_maiden_first_name || '',
      mother_maiden_last_name: taxpayer.mother_maiden_last_name || '',
      mother_maiden_middle_name: taxpayer.mother_maiden_middle_name || '',
      is_user_id_auth: taxpayer.is_user_id_auth,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChangePhoto = key => (value) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(taxpayers)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    getRegionsList();

    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  useEffect(() => {
    getProvinceList({
      region_code: _.get(taxpayer, 'place_of_birth_region_code'),
    });
  }, []);

  useEffect(() => {
    getMunicipalityList({
      province_code: _.get(
        taxpayer,
        'place_of_birth_province_code'
      ),
    });
  }, []);

  useEffect(() => {
    getBarangayList({
      municipality_code: _.get(
        taxpayer,
        'place_of_birth_municipality_code'
      ),
    });
  }, []);

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation);
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className='col-4'>
            <label className="form-label">
              Profile Photo {validateForm.renderMessage('photo')}
            </label>
            <img
              className="w-100 rounded"
              src={
                !_.isObject(_.get(formData, 'photo') || '')
                  ? _.get(formData, 'photo') || ImagePlaceholder
                  : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
              }
              alt=""
            />
            <FilePondSingleUpload onChange={onChangePhoto('photo')} />
          </div>
          <div className='col-8'>
            <div className='row'>
              <div className="col-6 form-group">
                <label className="form-label mb-2">
                  First Name {validateForm.renderMessage('first_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="first_name"
                  onChange={onChange}
                  value={_.get(formData, 'first_name') || ''}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-2">
                  Middle Name
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="middle_name"
                  onChange={onChange}
                  value={_.get(formData, 'middle_name') || ''}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-2">
                  Last Name {validateForm.renderMessage('last_name')}
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="last_name"
                  onChange={onChange}
                  value={_.get(formData, 'last_name') || ''}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="extension_name" className="form-label mb-2">
                  Extension Name
                </label>
                <Select
                  name="extension_name"
                  onChange={handleOnChangeSelect('extension_name')}
                  options={c.EXTENSION_NAMES}
                  value={
                    c.EXTENSION_NAMES.find(
                      (item) =>
                        _.get(formData, 'extension_name') === _.get(item, 'value')
                    ) || ''
                  }
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label mb-2">
                  Email Address 
                </label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  onChange={onChange}
                  value={_.get(formData, 'email') || ''}
                  autoComplete="off"
                  disabled
                />
              </div>
              <div className="col-6">
                <label className="form-label">
                  Mobile Number 
                </label>
                <FormInputMobile
                  disableDropdown={false}
                  autoComplete="off"
                  autoFocus
                  type="tel"
                  name="mobile_number"
                  onChange={setFormMobile}
                  value={_.get(formMobile, 'mobile_number')}
                  disabled
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Civil Status:</label>
                <Select
                  styles={customStyle}
                  value={
                    c.CIVIL_STATUSES.find(
                      (item) =>
                        _.get(formData, 'civil_status') === _.get(item, 'value')
                    ) || ''
                  }
                  onChange={handleOnChangeSelect('civil_status')}
                  options={c.CIVIL_STATUSES}
                />
              </div>
              <div className="col-6 form-group">
                <label htmlFor="gender" className="form-label">
                  Sex: {validateForm.renderMessage('gender')}
                </label>
                <Select
                  styles={customStyle}
                  value={
                    c.GENDERS.find(
                      (item) => _.get(formData, 'gender') === _.get(item, 'value')
                    ) || ''
                  }
                  onChange={handleOnChangeSelect('gender')}
                  options={c.GENDERS}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">
                  Birthdate:{' '}{validateForm.renderMessage('birth_date')}
                </label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleOnChangeDate('birth_date')}
                  value={_.get(formData, 'birth_date') || ''}
                  maxDate={new Date()}
                />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row d-flex justify-content-start text-primary font-weight-bold mx-0 mb-2">
          Place of Birth
        </div>
        <div className="row">
          <div className="col-4 form-group">
            <label className="form-label">
              Region {validateForm.renderMessage('place_of_birth_region_code')}
            </label>
            <Select
              styles={customStyle}
              placeholder="Select Region"
              value={region}
              options={createDropdown(regionsList)}
              onChange={(e) => {
                handleRegionSelect(e);
              }}
            />
          </div>
          <div className="col-4 form-group">
            <label className="form-label">
              Province {validateForm.renderMessage('place_of_birth_province_code')}
            </label>
            <Select
              value={province}
              styles={customStyle}
              placeholder="Select Province"
              options={createDropdown(provinceList)}
              onChange={(e) => {
                handleProvinceSelect(e);
              }}
            />
          </div>
          <div className="col-4 form-group">
            <label className="form-label">
              City/Municipality {validateForm.renderMessage('place_of_birth_municipality_code')}
            </label>
            <Select
              options={createDropdown(municipalityList)}
              styles={customStyle}
              placeholder="Select City/Municipality"
              value={municipality}
              onChange={(e) => {
                handleMunicipalitySelect(e);
              }}
            />
          </div>
        </div>
        <hr />
        <div className="row d-flex justify-content-start text-primary font-weight-bold mx-0 mb-2">
          Document Owner&apos;s Mother Information
        </div>
        <div className="row">
          <div className="col-4 form-group">
            {createInput(
              { key: 'mother_maiden_first_name', label: 'Mother First Name' },
              {
                placeholder: 'Input mother first name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
          <div className="col-4 form-group">
            {createInput(
              { key: 'mother_maiden_last_name', label: 'Mother Last Name' },
              {
                placeholder: 'Input mother last name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
          <div className="col-4 form-group">
            {createInput(
              {
                key: 'mother_maiden_middle_name',
                label: 'Mother Middle Name',
              },
              {
                placeholder: 'Input mother middle name',
                className: 'text-uppercase form-control',
              }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating || 
              !validateForm.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark"
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ProfileEditModal.propTypes = {
  taxpayerId: PropTypes.string.isRequired,
  taxpayers: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateProfile: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  handleVerifyOtp: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_PROFILE) > -1,
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ProfileEditModal);
